import { AKAsList, DealContactsListItem } from '~/models/contacts.dto';

export class User {
    userId!: number;
    name!: string;
    companyName!: string;
    creatorCompanyName!: string;
    address!: string;
    route!: string;
    countryName!: string;
    cityName!: string;
    zipCode!: string;
    phone!: string;
    phone2!: string;
    phone3!: string;
    phone4!: string;
    phoneType!: number;
    phoneType2!: number;
    phoneType3!: number;
    phoneType4!: number;
    creatorKonAddId!: number;
    konAddId!: number;
    email!: string;
    image!: any;
    role!: string;
    creatorCode!: string;
    fullName!: string;
    country!: string;
    description!: string;
    kontactId!: number;
    kontactCode!: any;
    contacts!: User[];
    position!: string;
    contactType?: number;
    contactTypeDesc!: string;
    contactStatus!: string;
    contactCode!: string;
    contactId!: any;
    firstName!: any;
    lastName!: any;
    startDate!: any;
    endDate!: any;
    ipiList!: IpiListProps[];
    street!: any;
    addressLine1!: any;
    addressLine2!: any;
    addressLine3!: any;
    addressLine4!: any;
    projectContactId!: number;
    AKAsList!: AKAsList[];
    dealContacts!: DealContactsListItem[];
}

export class IpiListProps {
    additionalIpNumber!: string | null;
    affiliation!: string | null;
    affiliationCode!: string | null;
    createdBy!: number;
    iPNumber!: string;
    knownAs!: string | null;
    kontactCode!: string;
    kontacts_IPI_Id!: number;
    modifiedBy!: number;
    modifiedDate!: string;
}

export class AppUser extends User {
    token!: string;
}

export enum AddContactFormNames {
    COMPANY_NAME = 'COMPANY_NAME',
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    PHONE = 'PHONE',
    PHONE2 = 'PHONE2',
    PHONE3 = 'PHONE3',
    PHONE4 = 'PHONE4',
    PHONEType = 'PHONEType',
    PHONEType2 = 'PHONE2Type',
    PHONEType3 = 'PHONE3Type',
    PHONEType4 = 'PHONE4Type',
    KONAddId = 'konAddId',
    EMAIL = 'EMAIL',
    COUNTRY_NAME = 'country',
    ROUTE = 'route',
    CITY_NAME = 'locality',
    ZIP_CODE = 'postal_code',
    DESCRIPTION = 'DESCRIPTION',
    ADDRESS_LINE_1 = 'ADDRESS_LINE_1',
    ROLE = 'ROLE',
    IMAGE = 'IMAGE',
    creatorId = 'creatorId',
    startDate = 'startDate',
    endDate = 'endDate',
    contactId = 'contactId',
    contactCode = 'contactCode',
    CREATOR_ROLE = 'CREATOR_ROLE',
    CREATOR_FULL_NAME = 'CREATOR_FULL_NAME',
    ipiList = 'ipiList',
    kontacts_IPI_Id = 'kontacts_IPI_Id',
    iPNumber = 'iPNumber',
    affiliation = 'affiliation',
    kontactCode = 'kontactCode',
    legalEntity = 'legalEntity',
    addressLine1 = 'addressLine1',
    addressLine2 = 'addressLine2',
    addressLine3 = 'addressLine3',
    addressLine4 = 'addressLine4',
    AKAsList = 'AKAsList',
}

export type NewUser = {
    [key in AddContactFormNames]: any;
};
export interface addContact {}
